import { categories } from '../../../mocks/news';

const tone = ['primary', 'accent', 'secondary', 'primary', 'accent', 'secondary'] as const;

export default function Categories() {
  return (
    <section id="category" className="scroll-mt-24 py-12 md:py-16 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
          <div>
            <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">CATEGORIES</span>
            <h2 className="mt-1 font-heading text-2xl md:text-4xl font-black text-foreground-950">热点分类</h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            六大常设栏目，从明星娱乐到社会热点，无论你爱看哪种瓜，都能第一时间定位到正在刷屏的那一个。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((c, i) => {
            const t = tone[i % tone.length];
            const bubble =
              t === 'primary' ? 'bg-primary-100 text-primary-700'
              : t === 'accent' ? 'bg-accent-100 text-accent-800'
              : 'bg-secondary-100 text-secondary-800';
            const tag =
              t === 'primary' ? 'bg-primary-50 text-primary-700 border-primary-200'
              : t === 'accent' ? 'bg-accent-50 text-accent-800 border-accent-200'
              : 'bg-secondary-50 text-secondary-800 border-secondary-200';
            return (
              <a
                key={c.key}
                href="#feeds"
                className="group cursor-pointer rounded-2xl border border-background-200 bg-background-50 p-5 hover:border-background-300 hover:-translate-y-1 transition"
              >
                <div className="flex items-start justify-between">
                  <span className={`flex w-12 h-12 items-center justify-center rounded-xl ${bubble}`}>
                    <i className={`${c.icon} text-2xl`} aria-hidden="true" />
                  </span>
                  <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${tag}`}>
                    <i className="ri-fire-fill text-xs" aria-hidden="true" /> {c.hot}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition">
                  {c.name}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                  <span>{c.count}</span>
                  <span className="flex items-center gap-1 text-foreground-600 group-hover:gap-2 transition-all">
                    进入栏目 <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}